import { useQueryClient } from 'query';

interface IHookResponse {
  onMutate: (changedData: any) => Promise<{ previousData: any }>;
  onError: (err: any, _changedData: any, context: any) => void;
  onSettled: () => void;
}
interface IHook {
  queryKey: readonly unknown[];
  optimisticUpdate: (changedData: any, previousData: any[]) => any;
}
export const useOptimisticUpdate = ({
  queryKey,
  optimisticUpdate,
}: IHook): IHookResponse => {
  const queryClient = useQueryClient();
  return {
    onMutate: async (changedData: any) => {
      await queryClient.cancelQueries({ queryKey });

      // Snapshot the previous value
      const previousData = queryClient.getQueryData(queryKey);

      queryClient.setQueryData(queryKey, (previousPresets: any) => {
        return optimisticUpdate(changedData, previousPresets);
      });
      return { previousData };
    },
    // If the mutation fails,
    // use the context returned from onMutate to roll back
    onError: (_err: any, _changedData: any, context: any) => {
      queryClient.setQueryData(queryKey, context.previousData);
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: queryKey });
    },
  };
};
